import { Button } from '@iwoca/orion';

import UnhappyCritter from '../../../components/svg/Critters/UnhappyCritter.svg?react';
import { StatusTemplate } from '../StatusTemplate/StatusTemplate';

export function PaymentError() {
  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <StatusTemplate>
      <h2>Oops, something went wrong.</h2>
      <UnhappyCritter />
      <Button variant="action" onClick={refreshPage} className="my-m w-full">
        Try again?
      </Button>
    </StatusTemplate>
  );
}
